import { render } from "./AccountButton.vue?vue&type=template&id=d70e713c&scoped=true"
import script from "./AccountButton.vue?vue&type=script&lang=js"
export * from "./AccountButton.vue?vue&type=script&lang=js"

import "./AccountButton.vue?vue&type=style&index=0&id=d70e713c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70e713c"]])

export default __exports__